const _SignatureTip_active = Symbol("#active"),
      _SignatureTip_renderInfo = Symbol("#renderInfo"),
      _SignatureTip_renderInfoParameter = Symbol("#renderInfoParameter"),
      _SignatureTip_cm = Symbol("#cm"),
      _SignatureTip_elements = Symbol("#elements");

import { renderParts } from "../helpers/render-parts.js";
const displayKindToClassMap = {
  keyword: 'cm-keyword'
};
export class SignatureTip {
  constructor(cm) {
    this[_SignatureTip_active] = false;

    this[_SignatureTip_renderInfo] = (parent, signature) => {
      const {
        info
      } = signature;
      if (!info) return;

      if (info.parts.length > 0) {
        const element = document.createElement('div');
        renderParts(element, info.parts);
        parent.appendChild(element);
      }

      const {
        parameter
      } = info;
      if (!parameter) return;

      this[_SignatureTip_renderInfoParameter](parent, parameter);
    };

    this[_SignatureTip_renderInfoParameter] = (parent, parameter) => {
      if (parameter.parts.length === 0) return;
      const element = document.createElement('div');
      element.className = 'mirrorsharp-signature-info-parameter';
      const nameElement = document.createElement('span');
      nameElement.className = 'mirrorsharp-signature-info-parameter-name';
      nameElement.innerText = parameter.name + ': ';
      element.appendChild(nameElement);
      renderParts(element, parameter.parts);
      parent.appendChild(element);
    };

    this[_SignatureTip_cm] = cm;
  }

  update({
    signatures,
    span
  }) {
    let {
      tooltip,
      ol
    } = this[_SignatureTip_elements] ?? {};

    if (!tooltip) {
      tooltip = document.createElement('div');
      tooltip.className = 'mirrorsharp-theme mirrorsharp-any-tooltip mirrorsharp-signature-tooltip';
      ol = document.createElement('ol');
      tooltip.appendChild(ol);
      this[_SignatureTip_elements] = {
        tooltip,
        ol
      };
    } else {
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      ol = ol;
    }

    if (!signatures || signatures.length === 0) {
      if (this[_SignatureTip_active]) this.hide();
      return;
    }

    while (ol.firstChild) {
      ol.removeChild(ol.firstChild);
    }

    for (const signature of signatures) {
      const li = document.createElement('li');
      if (signature.selected) li.className = 'mirrorsharp-signature-selected';

      for (const part of signature.parts) {
        let className = displayKindToClassMap[part.kind] ?? '';
        if (part.selected) className += ' mirrorsharp-signature-part-selected';
        let child;

        if (className) {
          child = document.createElement('span');
          child.className = className;
          child.textContent = part.text;
        } else {
          child = document.createTextNode(part.text);
        }

        li.appendChild(child);
      }

      this[_SignatureTip_renderInfo](li, signature);

      ol.appendChild(li);
    } // eslint-disable-next-line @typescript-eslint/no-non-null-assertion


    const startPos = this[_SignatureTip_cm].posFromIndex(span.start);

    this[_SignatureTip_active] = true;

    const startCharCoords = this[_SignatureTip_cm].charCoords(startPos);

    tooltip.style.top = startCharCoords.bottom + 'px';
    tooltip.style.left = startCharCoords.left + 'px';
    document.body.appendChild(tooltip);
  }

  hide() {
    if (!this[_SignatureTip_active]) return; // eslint-disable-next-line @typescript-eslint/no-non-null-assertion

    document.body.removeChild(this[_SignatureTip_elements].tooltip);
    this[_SignatureTip_active] = false;
  }

}